module.exports = __webpack_public_path__ + "static/media/nxs.cfb414e0.svg";